import { HTTP } from '../../http';
import router from '../../router/index';

const state = {
  isFetchingList: false
};

const mutations = {
  setIsFetchingList: (state, status) => (state.isFetchingList = status)
};

const getters = {
  getIsFetchingList: state => state.isFetchingList
};

const actions = {
  getListOfClients: ({ commit }, searchText, pageNumber) => {
    commit('setIsFetchingList', true);
    setTimeout(() => {
      commit('setIsFetchingList', false);
    }, 1000);
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
